import PowerSavingTemplate from '../../templates/settings/ui/powerSaving';

export default function PowerSavingPage() {
  return <PowerSavingTemplate />;
}
